<template>
    <div class="channel-effect">
        <el-divider content-position="left">渠道效果数据</el-divider>
        <div style="margin-top: 1rem;" id="date-con">
            <el-date-picker size="small" v-model="tabDate" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd" @change="handleSearch">
            </el-date-picker>
            <customer-source
                style="display: inline-block;margin-left: 0.2rem;margin-right: 0.2rem; vertical-align: middle"
                @choosed="choosed"></customer-source>

            <el-button size="small" type="warning">导 出</el-button>
        </div>

        <div style="margin-top: 2rem;margin-bottom: 0.2rem;color: #409EFF;font-size: large;">
            {{ showDate }}
        </div>
        <table id="field-table" border>
            <tr>
                <td>时间</td>
                <td>一级渠道</td>
                <td>二级渠道</td>
                <td>线索量</td>
                <td>下单量(下单未成交)</td>
                <td>成交量</td>
                <td>信息表数</td>
                <td>下证数</td>
                <td>首次下单金额</td>
                <td>续费金额</td>
                <td>总业绩之和</td>
            </tr>
            <tr v-for="(item, key, index) in countData" :key="key">
                <td>{{ showDate }}</td>
                <td>{{ }}</td>
                <td>{{ key }}</td>
                <td>{{ item.clue }}</td>
                <td>{{ item.order_undeal }}</td>
                <td>{{ item.order_deal }}</td>
                <td>{{ item.reg_count }}</td>
                <td>{{ item.reg_license }}</td>
                <td>{{ item.first_pay }}元</td>
                <td>{{ item.renew }}元</td>
                <td>{{ item.total_created }}元</td>
            </tr>
            <tr>
                <td>{{ countCountData.name }}</td>
                <td>{{ }}</td>
                <td>{{ }}</td>
                <td>{{ countCountData.clueComp }}</td>
                <td>{{ countCountData.order_undealComp }}</td>
                <td>{{ countCountData.order_dealComp }}</td>
                <td>{{ countCountData.reg_countComp }}</td>
                <td>{{ countCountData.reg_licenseComp }}</td>
                <td>{{ countCountData.first_payComp }}元</td>
                <td>{{ countCountData.renewComp }}元</td>
                <td>{{ countCountData.total_createdComp }}元</td>
            </tr>
        </table>
    </div>
</template>

<script>
import CustomerSource from '../../../commonReform/CustomerSource'
import { fscDate } from '../../../../static/mixins/fastChooseDate';
export default {
    name: 'ChannelEffect',
    mixins: [fscDate],
    components: { CustomerSource },
    data() {
        return {
            // tabDate: this.ysyCurMonth(),
            tabDate: '',
            customerSource: [],
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501"
                    : "https://qyh-next-server.zhang66.cn",
            countData: {},
            countCountData: [],
        }
    },
    methods: {
        // showDate(date) {
        //     if (!date) {
        //         return this.ysyCurMonthForHuamn(this.ysyCurMonth())
        //     }
        //     return this.ysyCurMonthForHuamn(date)
        // },
        choosed(val) {
            this.customerSource = val
            this.loadTable()
        },
        handleSearch(val) {
            // if (val) {
            //     this.loadTable()
            // } else {

            // }
            this.loadTable()
        },
        clearCountData() {
            this.countData = this.$options.data().countData
        },
        loadTable() {
            this.clearCountData()
            this.$axios.get(`${this.hyperfHost}/v1/api/channel/effect/get_data`, {
                params: {
                    date: this.tabDate ? this.tabDate : this.ysyCurMonth(),
                    customerSource: this.customerSource
                }
            }).then(({ data }) => {
                this.countData = data[0]
                this.countCountData = data[1]
            }).catch()
        }
    },
    computed: {
        showDate() {
            if (this.tabDate) {
                return this.ysyCurMonthForHuamn(this.tabDate)
            }
            return this.ysyCurMonthForHuamn(this.ysyCurMonth())
        },
        // countCountData() {
        //     const data = {
        //         name2: '合计',
        //         clueComp: 0,
        //         order_undealComp: 0,
        //         order_dealComp: 0,
        //         reg_countComp: 0,
        //         reg_licenseComp: 0,
        //         first_payComp: 0,
        //         renewComp: 0,
        //         total_createdComp: 0,
        //     }
        //     if (JSON.stringify(this.countData) !== '{}') {
        //         for (let key in this.countData) {
        //             data.clueComp += this.countData[key].clue
        //             data.order_undealComp += this.countData[key].order_undeal
        //             data.order_dealComp += this.countData[key].order_deal
        //             data.reg_countComp += this.countData[key].reg_count
        //             data.reg_licenseComp += this.countData[key].reg_license
        //             data.first_payComp += parseFloat(this.countData[key].first_pay)
        //             data.renewComp += parseFloat(this.countData[key].renew)
        //             data.total_createdComp += parseFloat(this.countData[key].total_created)

        //         }
                
        //     }
        //     return data
        // }
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
.channel-effect {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.channel-effect #date-con>>>.el-input__inner {
    height: 33px !important;
}

/* 表格 */
.channel-effect .centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

.channel-effect #field-table td {
    padding: 0.2rem 0.3rem;
}

.channel-effect .centered-count {
    text-align: right;
}

/* 表格end */
</style>


// WEBPACK FOOTER //
// src/pages/PromotionStatistics/ChannelEffect/ChannelEffect.vue